<template>
    <div class="message-item show" :class="getCurrent.class">
        <p>{{notification.message}}</p>
        <span title="Close" class="js-close-message" @click="close">
                <icon-base width="24" height="24" viewBox="0 0 24 24"><icon-cross/></icon-base>
            </span>
        <div class="bg-icon">
            <icon-base width="28" height="28" viewBox="0 0 28 28"><component :is="getCurrent.component" v-bind:key="index"/></icon-base>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import IconBase from "./IconBase";
    import IconCross from "./icons/IconCross";
    import IconSuccess from "./icons/IconSuccess";
    import IconError from "./icons/IconError";
    import IconWarning from "./icons/IconWarning";
    import IconNotification1 from "./icons/IconNotification1";
    import IconNotification2 from "./icons/IconNotification2";
    import {markRaw} from "vue"

    export default {
        name: 'notification',
        components: {IconNotification2, IconNotification1, IconError, IconSuccess, IconCross, IconBase},
        props: {
            notification: Object,
            index: Number,
            type: {
                type: String,
                default: "notification1"
            },
            interval: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                current: {},
                icons:
                    [
                        {
                            component: markRaw(IconSuccess),
                            type: "success",
                            class: ""
                        },
                        {
                            type: "error",
                            component: markRaw(IconError),
                            class: "error-view"
                        },
                        {
                            type: "notification1",
                            component: markRaw(IconNotification1),
                            class: "info-view"
                        },
                        {
                            type: "notification2",
                            component: markRaw(IconNotification2),
                            class: "info-view"
                        },
                        {
                            type: "warning",
                            component: markRaw(IconWarning),
                            class: "warning-view"
                        }
                    ]
            }
        },
        mounted() {
            this.current = this.icons.find(obj => {
                return obj.type === this.type
            });

            let x = setInterval(() => {
                this.closeNotification(this.index);
                clearInterval(x)
            }, 1000 * this.interval);
        },

        computed: {
            ...mapState({
                notifications: state => state.notifications,
            }),

            getCurrent() {
                return this.icons.find(obj => {
                    return obj.type === this.type
                });
            }
        },
        methods: {
            ...mapMutations( [
                'closeNotification'
            ]),
            close() {
                this.closeNotification(this.index);
            }
        }
    }
</script>

<style scoped>

</style>
